"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const theme_1 = require("@zapier/theme");
const DrawerContainer_1 = __importDefault(require("./DrawerContainer"));
const DrawerSibling_1 = __importDefault(require("./DrawerSibling"));
const DrawerTabContent_1 = __importDefault(require("./DrawerTabContent"));
const DrawerTabs_1 = __importDefault(require("./DrawerTabs"));
const DrawerTabContext_1 = require("./DrawerTabContext");
const Constants_1 = require("./Constants");
const containerCss = ({ isOpen, breakpoint, zIndex, }) => ({
    display: 'flex',
    position: 'relative',
    zIndex,
    right: 0,
    height: '100%',
    [`@media ${breakpoint}`]: {
        position: isOpen ? 'absolute' : 'relative',
        boxShadow: isOpen ? '0px 5px 10px 0px rgba(0, 0, 0, 0.1)' : 'none',
    },
});
const borderLeftWidth = 1;
const drawerCss = ({ isOpen, breakpoint, widthDesktop, widthMobile, }) => core_1.css({
    display: 'block',
    maxWidth: isOpen ? widthDesktop : 0,
    minWidth: isOpen ? widthDesktop : 0,
    backgroundColor: theme_1.Colors.white,
    borderLeft: isOpen
        ? `${borderLeftWidth}px solid ${theme_1.Colors.adamantium}`
        : 'none',
    overflow: 'auto',
    [`@media ${breakpoint}`]: {
        marginLeft: 'auto',
        height: '100%',
        maxWidth: isOpen ? widthMobile : 0,
        minWidth: isOpen ? widthMobile : 0,
    },
});
const Drawer = ({ breakpoint = Constants_1.BREAKPOINT, children, formatTabItemCount, isOpen, onTabChanged, openTabId, tabs, widthDesktop = Constants_1.WIDTH_DESKTOP, widthMobile = Constants_1.WIDTH_MOBILE, zIndex, }) => tabs ? (core_1.jsx(DrawerTabContext_1.DrawerTabController, { onChanged: onTabChanged, selectedTabId: openTabId },
    core_1.jsx("div", { css: containerCss({
            isOpen: isOpen || !!openTabId,
            breakpoint,
            zIndex,
        }) },
        core_1.jsx(DrawerTabs_1.default, { formatTabItemCount: formatTabItemCount, items: tabs }),
        core_1.jsx("aside", { "aria-label": "sidebar", css: drawerCss({
                isOpen: isOpen || !!openTabId,
                breakpoint,
                widthDesktop,
                widthMobile,
            }) }, children)))) : (core_1.jsx("aside", { "aria-label": "sidebar", css: drawerCss({
        isOpen: !!isOpen,
        breakpoint,
        widthDesktop,
        widthMobile,
    }) }, children));
Drawer.defaultProps = {
    breakpoint: Constants_1.BREAKPOINT,
    isOpen: false,
    widthDesktop: Constants_1.WIDTH_DESKTOP,
    widthMobile: Constants_1.WIDTH_MOBILE,
    zIndex: 10,
};
Drawer.Container = DrawerContainer_1.default;
Drawer.Sibling = DrawerSibling_1.default;
Drawer.Tabs = DrawerTabs_1.default;
Drawer.TabContent = DrawerTabContent_1.default;
Drawer.ClosedWidth = DrawerTabs_1.default.Width + borderLeftWidth;
Drawer.drawerOverlayMediaQuery = Constants_1.BREAKPOINT;
exports.default = Drawer;
